import React from 'react';

interface DocumentFileIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const DocumentFileIcon: React.FC<DocumentFileIconProps> = ({
  className = '',
  size = 32,
  color = '#0054A4',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M26.6667 29.3333H5.33333C4.6 29.3333 4 28.7333 4 28V4C4 3.26667 4.6 2.66667 5.33333 2.66667H18.6667L28 12V28C28 28.7333 27.4 29.3333 26.6667 29.3333Z"
        fill={color}
      />
      <path d="M10.5335 21.1067H5.1335V15.7067H10.5335V21.1067Z" fill={color} />
      <path d="M14.8255 21.1067H11.1655V15.7067H14.8255V21.1067Z" fill={color} />
      <path d="M20.8735 21.1067H15.7715V15.7067H20.8735V21.1067Z" fill={color} />
    </svg>
  );
};

export default DocumentFileIcon;
